module.exports = __webpack_public_path__ + "static/DHCM0-dcbee66a4eb1d81ee83c62ff02b10389.jpg";